import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { handleDocumentUpload } from "../../thunks/editor/documentThunk";
import { showToast } from "../../utils/general";
import { useNavigate } from "react-router-dom";

const waringMessage = "The uploaded file should not contain more than 5 pages";

const UploadTwo = ({ acceptedFile, handleBack }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedSlide, setSelectedSlide] = useState(1);

  const handleSlideChange = (event) => {
    setSelectedSlide(event.target.value);
  };

  return (
    <div className="max-w-[60%] flex flex-col gap-4 m-auto  w-full bg-gray-100 h-full justify-center">
      <div className="flex flex-col bg-gray-100 w-full justify-center items-center ">
        <div className="bg-white border-[1px]  rounded p-8 items-center w-full">
          <div className="flex justify-between">
            <div>
              <h1 className="font-bold">
                Define the number of slides for your video
              </h1>
              <h1 className="font-semibold text-sm text-gray-500">
                Note: <span className="text-vb-violet">{waringMessage}</span>
              </h1>
            </div>
            <select
              name="slides"
              id="slides"
              className="border-2 w-[100px] pr-2 rounded-md"
              value={selectedSlide}
              onChange={handleSlideChange}
            >
              {[...Array(10).keys()].map((num) => (
                <option key={num + 1} value={num + 1}>
                  {num + 1}
                </option>
              ))}
            </select>
          </div>
          {acceptedFile && (
            <div className="border-2 rounded-sm  p-2 mt-4 flex items-center justify-between">
              <p className="font-semibold text-sm text-gray-400 ">
                {acceptedFile.name}
              </p>

              <p className="font-bold text-blue-500 text-xs">
                {" "}
                {(acceptedFile.size / 1024).toFixed(2)} KB
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-end items-center gap-2">
        <button
          onClick={() => navigate("/tool/dashboard")}
          className="text-black text-sm font-semibold rounded-md p-2 bg-white hover border border-black"
        >
          Cancel
        </button>
        <button
          className="text-white w-fit flex justify-end text-sm font-semibold rounded-md p-2 bg-black"
          onClick={() =>
            dispatch(
              handleDocumentUpload(acceptedFile, { slides: selectedSlide })
            )
          }
        >
          Create Your First Cut
        </button>
      </div>
    </div>
  );
};

const DocumentUpload = ({ className }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const navigate = useNavigate();
  const [acceptedFile, setAcceptedFile] = useState(null);
  const [showUploadTwo, setShowUploadTwo] = useState(false);
  const fileInputRef = useRef(null);

  const handleBack = () => {
    if (showUploadTwo) {
      setShowUploadTwo(false);
    } else {
      navigate("/dashboard");
    }
  };

  const validateFileType = (file) => {
    const allowedExtensions = [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
    return allowedExtensions.includes(file.type);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0 && validateFileType(files[0])) {
      setAcceptedFile(files[0]);
      console.log("File dropped:", files[0]);
    } else {
      console.log("Invalid file type");
    }
    setIsDragOver(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files[0].size > 1024 * 1024 * 50) {
      showToast("50 mb max file size.", "", "danger");
      return;
    }
    if (files.length > 0 && validateFileType(files[0])) {
      setAcceptedFile(files[0]);
      setShowUploadTwo(true);

      console.log("File selected:", files[0]);
    } else {
      console.log("Invalid file type");
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    if (acceptedFile) {
      setShowUploadTwo(true);
    }
  };

  return (
    <div
      className={`flex flex-col bg-gray-100 h-full border shadow ${
        className || ""
      }`}
    >
      <div className="border-2 flex bg-gradient-to-b from-gray-200 to-white p-2 text-sm font-semibold">
        {showUploadTwo && (
          <button onClick={handleBack} className="mx-4 flex mr-6">
            <img
              className="w-[20px] mr-2"
              src="/tool/dashboard/static/images/backsquare.png"
            />
            <p>Back</p>
          </button>
        )}
        <h1>Create Video from document</h1>
      </div>
      {!showUploadTwo ? (
        <>
          <div className="bg-white border-[1px] my-12 mx-auto rounded w-[60%] p-8 items-center">
            <div
              className={`border-2 p-8 flex flex-col items-center justify-center rounded-md ${
                isDragOver ? "border-blue-500" : "border-dotted"
              }`}
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
            >
              <button onClick={handleButtonClick}>
                <img
                  src="/tool/dashboard/static/images/fileupload.svg"
                  alt="Upload Icon"
                />
              </button>
              <h1 className="font-bold mt-6 my-2">
                Drag & drop your file here or{" "}
                <label
                  htmlFor="file-upload"
                  className="text-blue-600 cursor-pointer underline"
                >
                  <b>choose file</b>
                </label>
              </h1>
              <input
                id="file-upload"
                type="file"
                accept=".doc,.docx,.pdf"
                className="hidden"
                value={""}
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              <p className="font-semibold text-gray-400">50 mb max file size</p>
              <p className="font-semibold text-vb-violet">{waringMessage}</p>
            </div>
          </div>
          <button
            onClick={handleBack}
            className="text-black w-[120px] text-sm font-semibold rounded-md py-2 px-4 ml-[68%] bg-white hover border border-black"
          >
            Cancel
          </button>
        </>
      ) : (
        <UploadTwo acceptedFile={acceptedFile} handleBack={handleBack} />
      )}
    </div>
  );
};

export default DocumentUpload;
